import React, { useEffect } from 'react';
import { Route, RouteProps, useHistory } from 'react-router-dom';
import useTrackPageView from '../../hooks/tracking/use-track-page-view';
import {
  useIsPaymentProblemShop,
  useIsPaymentProblemSubscription
} from '../../common/use-is-payment-problem';
import { getPaymentProblemRedirect } from './get-payment-problem-redirect';
import { getPaymentInfo } from '../../modules/selectors/paymentInfo';
import { useSelector } from 'react-redux';

const SubscriptionRoute = (props: RouteProps & { pageId: string }) => {
  const history = useHistory();
  const { paymentProvider } = useSelector(getPaymentInfo);
  const { isPaymentProblem, state } = useIsPaymentProblemSubscription();
  const { isPaymentProblem: isPaymentProblemShop } = useIsPaymentProblemShop();
  const {
    location: { pathname, search }
  } = history;

  const trackPageView = useTrackPageView();
  useEffect(() => {
    trackPageView(props.pageId, props.path as string);
  }, []); // eslint-disable-line

  const redirectPath = getPaymentProblemRedirect({
    pathname,
    search,
    paymentProvider,
    subscriptionState: state,
    isPaymentProblemSubscription: isPaymentProblem,
    isPaymentProblemShop
  });

  if (redirectPath) {
    history.push(redirectPath);

    return null;
  }

  return <Route {...props} />;
};

export default SubscriptionRoute;
